export const FafKey = {
  PRODUCT_ID: 'productId',
  FUEL_SOLD: 'fuelSold'
};
export const FafLabel = {
  PRODUCT_ID: 'Product Name',
  FUEL_SOLD: 'Fuel Sold'
};
